(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["albi-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('albi-home-hero')) {
    customElements.define('albi-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.phrases = Array.from(this.querySelectorAll('.albi-hero__phrase'));
        this.button = this.querySelector('.albi-hero__pause');
        this.index = 0;
        this.paused = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.button.textContent = this.paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel;
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const phrase = event.target.closest('.albi-hero__phrase');
          if (phrase) { this.show(this.phrases.indexOf(phrase)); this.editorPaused = true; this.sync(); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.sync(); }, options);
        this.sync();
      }
      show(index) {
        this.index = index;
        this.phrases.forEach((phrase, i) => phrase.classList.toggle('is-active', i === index));
      }
      sync() {
        clearInterval(this.timer);
        this.button.hidden = this.phrases.length < 2 || this.motion.matches;
        if (this.paused || this.editorPaused || this.motion.matches || document.hidden || this.phrases.length < 2) return;
        this.timer = setInterval(() => this.show((this.index + 1) % this.phrases.length), Number(this.dataset.interval) || 3000);
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
